export default __webpack_public_path__ + "static/cash_flow-4654119e2d42a72a5c3dce0408355430.png";